exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-full[data-v-3c011c6a]{-webkit-transition:all 0.3s;-o-transition:all 0.3s;transition:all 0.3s}.button-full[data-v-3c011c6a]:hover{background-color:white;color:black;-webkit-box-shadow:inset 0px 0px 0px 3px black;box-shadow:inset 0px 0px 0px 3px black;font-weight:600}.disabled[data-v-3c011c6a]{background-color:gray}\n", ""]);

// exports
